import React from "react";
import styled from "styled-components";
import { Container, ContainerProps } from "@material-ui/core";
import { TOOLBAR_OFFSET } from "styles/utils";

// eslint-disable-next-line
export const AppContainer = styled(({ disableMargin, ...props }: ContainerProps & { disableMargin?: boolean }) => (
    <Container {...props} />
))`
    margin-top: ${({ disableMargin = false }) => (disableMargin ? 0 : TOOLBAR_OFFSET)}px;
    position: relative;
    flex-grow: 1;
    padding-left: ${({ theme }) => theme.spacing(1)}px;
    padding-right: ${({ theme }) => theme.spacing(1)}px;
`;
